// 图片上传
export const Upload = 'https://www.bestekdirect.com/index.php?route=forum/photos/upload'
export const Upload2 = 'https://www.bestekdirect.com/index.php?route=forum/photos/upload2'
export default{
  baseUrl:'https://www.bestekdirect.com',
  imgUrl:'https://www.bestekdirect.com',
}